import type { FolderBranchLineProps } from "./types";

export const FolderBranchLine = ({ branch }: FolderBranchLineProps) => (
  <>
    {branch === "middle" && (
      <span
        aria-hidden="true"
        className="absolute inset-y-0 left-0 w-px bg-gray-300"
      />
    )}
    {/* h-4 ends the branch level with the centre of the row's first line. */}
    <span
      aria-hidden="true"
      className="absolute left-0 top-0 h-4 w-3 rounded-bl-md border-b border-l border-gray-300"
    />
  </>
);
